"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaSeoMetadataEntity = void 0;
class MediaSeoMetadataEntity {
    ownerId;
    title;
    description;
    image;
    url;
    keywords;
    publisher;
    site_name;
    twitter_card;
    alt;
    ios;
    android;
    video;
}
exports.MediaSeoMetadataEntity = MediaSeoMetadataEntity;
